module.exports = __webpack_public_path__ + "img/img0.b16120a6.png";